import { useState, useEffect, useRef } from "react";
import * as React from "react";
import { KeyboardArrowUp } from '@mui/icons-material';

export default function ScrollToTopButton(props: { isMobile?: any; }) {
    const isMobile = props.isMobile;

    const [isVisible, setIsVisible] = useState(false);
    const prevScrollPos = useRef(0);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            const currentScrollPos = window.pageYOffset;

            if (currentScrollPos > 500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }

            prevScrollPos.current = currentScrollPos;
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, [isVisible]);

    return (
        <div className="scroll-to-top">
            {isVisible && (
                <button className="top-button" onClick={scrollToTop}>
                    <KeyboardArrowUp style={{ fontSize: isMobile ? 50 : 60 }} />
                </button>
            )}
        </div>
    );
}